<template>
    <div>
        <edit-production-hiatus-modal
            v-model="show_hiatus_dialog"
            :productionId="production.id"
            :modelProp="hiatusSelected"
            :constants="constants"
            @successful-hiatus-save="refreshHiatusData"
        />
        <div class="tw-flex tw-flex-row tw-gap-4 tw-p-1">
            <div class="tw-flex tw-flex-col tw-w-3/12"><!-- Left side -->
                <internal-table-section :hasButton="false">
                    <div class="input-container relative">
                        <div class="tw-flex tw-justify-between tw-items-start">
                <span class="tw-text-secondary">
                    Hiatus Dates
                </span>
                            <span class="tw-flex tw-justify-end">
                    <span class="tw-text-blue-500 custom-link" @click="addHiatus">Add Hiatus</span>
                </span>
                        </div>
                        <div class="mt-2">
                            <smart-table
                                id="productionshiatus_list"
                                :endpoint="route('productionshiatus.ajax_list', production.id)"
                                :headers="headers"
                                :items-per-page="20"
                                flat
                                class="row-pointer"
                                ref="productionshiatus_list"
                                @click:row="editHiatus"
                            >
                            </smart-table>
                        </div>
                    </div>
                </internal-table-section>
            </div>
            <v-form name="editForm" ref="editForm">
            <div class="tw-flex tw-flex-col"><!-- Middle side -->
                <internal-table-section class="w-full" :hasButton="false">
                    <div class="tw-flex tw-flex-wrap">
                        <div class="tw-w-1/3 tw-px-2">
                            <v-text-field v-model="production.location" label="Location"></v-text-field>
                        </div>
                        <div class="tw-w-1/3 tw-px-2">
                            <v-select v-model="production.payroll_company" :items="payrollValueList" label="Payroll Company"></v-select>
                        </div>
                        <div class="tw-w-1/3 tw-px-2">
                            <v-select v-model="production.fee_status" :items="statusValueList" label="Fee Status"></v-select>
                        </div>
                        <div class="tw-w-full tw-px-2">
                            <v-text-field v-model="production.company_name_internal" label="Production Company (Internal Use)"></v-text-field>
                        </div>
                        <div class="tw-w-1/3 tw-px-2">
                            <v-text-field v-model="production.bond_cg" label="Bond C.G"></v-text-field>
                        </div>
                        <div class="tw-w-1/3 tw-px-2">
                            <v-text-field v-model="production.uav_deal_memo" label="UAV Deal Memo"></v-text-field>
                        </div>
                        <div class="tw-w-1/3 tw-px-2">
                            <v-textarea auto-grow outlined hide-details="auto" v-model="production.non_member_fees" label="Non-Member Fees"></v-textarea>
                        </div>
                        <div class="tw-w-1/3 tw-px-2">
                            <v-text-field v-model="production.permit_fee" label="Permit Fee"></v-text-field>
                        </div>

                        <div class="tw-w-2/3 tw-px-2">&nbsp;</div>

                        <div class="tw-w-1/3 tw-px-2">
                            <v-text-field v-model="production.rates" label="Rates"></v-text-field>
                        </div>
                        <div class="tw-w-2/3 tw-px-2">
                            <v-text-field v-model="production.non_print_note" label="Print Comments" class="tw-pb-2"></v-text-field>
                        </div>
                    </div>
                </internal-table-section>

                <div class="tw-mt-4"> <!-- Bottom 2 divs -->
                    <div class="tw-flex tw-gap-4">
                        <div class="tw-w-4/5 tw-gap-1">
                            <internal-table-section :hasButton="false">
                                <v-text-field
                                    v-model="production.vacation_percent"
                                    label="Vac %"
                                    type="number"
                                    @input="handlePercentageInput('vacation_percent')"
                                />
                                <v-text-field
                                    v-model="production.levy_precent"
                                    label="Levy %"
                                    type="number"
                                    @input="handlePercentageInput('levy_precent')"
                                />
                                <v-text-field
                                    v-model="production.hw_percent"
                                    label="HW %"
                                    type="number"
                                    @input="handlePercentageInput('hw_percent')"
                                />
                                <v-text-field
                                    v-model="production.hw_amount"
                                    label="H&W $"
                                    type="number"
                                />
                                <v-text-field
                                    v-model="production.rrsp_percent"
                                    label="RRSP %"
                                    type="number"
                                    @input="handlePercentageInput('rrsp_percent')"
                                />
                                <v-text-field
                                    v-model="production.rrsp_amount"
                                    label="RRSP $"
                                    type="number"
                                />
                                <v-text-field
                                    v-model="production.dues"
                                    label="Dues %"
                                    type="number"
                                    @input="handlePercentageInput('dues')"
                                />
                                <v-text-field
                                    v-model="production.training_percent"
                                    label="Training %"
                                    type="number"
                                    @input="handlePercentageInput('training_percent')"
                                />
                            </internal-table-section>

                            <internal-table-section class="mt-4" :hasButton="false">
                                <div>
                                    <v-radio-group
                                        v-model="production.negotiating"
                                        class="mt-0 py-0"
                                        dense
                                        hide-details="auto"
                                    >
                                        <div class="tw-text-sm" style="color: rgba(0, 0, 0, 0.6)">Negotiation</div>
                                        <v-radio
                                            class="my-0"
                                            label="Yes"
                                            value="Yes"
                                        ></v-radio>
                                        <v-radio
                                            class="my-0"
                                            label="No"
                                            value="No"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                                <div>
                                    <v-radio-group
                                        v-model="production.signback"
                                        class="mt-0 py-0"
                                        dense
                                        hide-details="auto"
                                    >
                                        <div class="tw-text-sm" style="color: rgba(0, 0, 0, 0.6)">Signback</div>
                                        <v-radio
                                            class="my-0"
                                            label="Yes"
                                            value="Yes"
                                        ></v-radio>
                                        <v-radio
                                            class="my-0"
                                            label="No"
                                            value="No"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                                <div>
                                    <v-radio-group
                                        v-model="production.top_sheet"
                                        class="mt-0 py-0"
                                        dense
                                        hide-details="auto"
                                    >
                                        <div class="tw-text-sm" style="color: rgba(0, 0, 0, 0.6)">Top Sheet</div>
                                        <v-radio
                                            class="my-0"
                                            label="Yes"
                                            value="Yes"
                                        ></v-radio>
                                        <v-radio
                                            class="my-0"
                                            label="No"
                                            value="No"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>

                            </internal-table-section>

                        </div>
                        <div class="tw-w-1/5">
                            <internal-table-section :hasButton="false">
                                <div class="input-container">
                                    <div class="tw-w-full"><v-text-field v-model="production.camera" label="Camera"></v-text-field></div>
                                    <div class="tw-w-full"><v-text-field v-model="production.estimated_budget" label="Estimated Budget"></v-text-field></div>
                                    <div class="tw-w-full"><v-text-field v-model="production.estimated_budget_text" label="Estimated Budget Text"></v-text-field></div>
                                    <div class="tw-w-full"><v-text-field v-model="production.technicians" label="Technicians"></v-text-field></div>
                                </div>
                            </internal-table-section>
                        </div>
                    </div>
                </div>
            </div>
            </v-form>
        </div>
        <div class="save-button-container">
            <v-btn
                text
                @click="saveStatistics"
                class="main-btn"
                :loading="saveLoading"
            >
                Save
            </v-btn>
        </div>
    </div>
</template>


<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import EditProductionHiatusModal from "@/Pages/InternalPages/Productions/Modals/EditProductionHiatusModal";

    export default {
        name: "ProductionsShowStatistics",
        components: {
            SmartTable,
            InternalHeader,
            InternalTableSection,
            EditProductionHiatusModal,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        computed: {
            headers() {
                return [
                    {value: 'date_start',        text: 'Date Start',              align: `start`, sortable: false, optional: false, },
                    {value: 'date_end',         text: 'Date End',              align: `start`, sortable: false, optional: false, },
                ]
            },
            is_edit_mode() {
                    return this.mode == 'Edit' ? true : false
            },
        },
        data() {
            return {
                productionHiatus: [],
                vacation_percent:0,
                levy_precent:0,
                hw_percent:0,
                rrsp_percent:0,
                dues:0,
                training_percent:0,
                hiatusSelected: this.hiatus,
                show_hiatus_dialog: false,
                production: this.input,
                constant: this.constants,
                saveLoading: false,
                payrollValueList: [
                    {text: 'EP Canada',       value: this.constants.PAYROLL_COMPANY.PAYROLL_COMPANY_CANADA},
                    {text: 'EP US',   value: this.constants.PAYROLL_COMPANY.PAYROLL_COMPANY_US},
                    {text: 'Cast & Crew',   value: this.constants.PAYROLL_COMPANY.PAYROLL_COMPANY_CAST},
                    {text: 'Greenslate',   value: this.constants.PAYROLL_COMPANY.PAYROLL_COMPANY_GREEN},
                    {text: 'Extreme Reach',   value: this.constants.PAYROLL_COMPANY.PAYROLL_COMPANY_EXTREME},
                    {text: 'In House Payroll',   value: this.constants.PAYROLL_COMPANY.PAYROLL_COMPANY_HOUSE},
                ],
                statusValueList: [
                    {text: 'Waiting for final wages',       value: this.constants.FEE_STATUS.FEE_STATUS_WAITING},
                    {text: 'Invoiced',   value: this.constants.FEE_STATUS_INVOICED},
                    {text: 'Paid',   value: this.constants.FEE_STATUS_PAID},
                ],
            }
        },
        methods: {
            saveComment() {
                //
            },
            addHiatus() {
                this.hiatusSelected = null
                this.show_hiatus_dialog = true
            },
            editHiatus(item){
                this.hiatusSelected = item
                this.show_hiatus_dialog = true
            },
            refreshHiatusData() {
                this.$refs.productionshiatus_list.refreshList()
            },
            handlePercentageInput(field) {
                if (this.production[field] < 0) {
                    this.production[field] = 0;
                } else if (this.production[field] > 100) {
                    this.production[field] = 100;
                }
            },
            saveStatistics() {
                if (this.$refs.editForm.validate()) {
                    let formData = new FormData()
                    formData.append('id', this.production.id)
                    for (let key in this.production) {
                        if (this.production[key] !== null
                            && this.production[key] !== undefined
                            && this.production[key] !== 'undefined'
                        ) { // Adding three as system is not stable with this from time to time
                            formData.append(key, this.production[key]);
                        } else {
                            formData.append(key, '');
                        }
                    }

                    var url = ''

                    url = route('productions.update', this.production.id)
                    formData.append("_method", "put")


                    axios({
                        method: 'post',
                        url: url,
                        data: formData,
                        onUploadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.saveLoading = !this.saveLoading
                        },
                    })
                        .then(response =>
                        {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Changes have been saved')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.$emit('successful-manage-production-save')
                                this.$emit('save-loading-change')
                            } else if( response.data?.error ) {
                                throw (response.data?.error)
                            } else {
                                throw ('Unknown error.')
                            }
                        })
                        .catch((error) => {
                            this.saveLoading = false
                            this.$root.handleErrors(error);
                        })

                } else {
                    this.$root.snackbar.error('Please fill all required fields.')
                }
            },
        }
    }
</script>

<style>
.custom-link {
    cursor: pointer;
    text-decoration: underline;
}
.save-button-container {
    position: relative;
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
}
</style>
